import { Fragment, type JSX } from "react";

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import { typedObjectEntries } from "common/helpers/utils";
import type { WorkspaceAccount } from "common/types";

import { MANAGE_ACCOUNTS_ACTIONS } from "../../constants";

export default function MobileDrawer({
  action,
  setAction,
  selectedAccounts,
  children,
}: {
  action: keyof typeof MANAGE_ACCOUNTS_ACTIONS;
  setAction: (action: keyof typeof MANAGE_ACCOUNTS_ACTIONS) => void;
  selectedAccounts: WorkspaceAccount[];
  children: JSX.Element;
}) {
  const ActionComponent = action
    ? MANAGE_ACCOUNTS_ACTIONS[action].component
    : undefined;

  return (
    <Drawer onAfterClose={() => setAction(undefined)}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent>
        {action ? (
          <ActionComponent
            selectedAccounts={selectedAccounts}
            onBack={() => {
              setAction(undefined);
            }}
          />
        ) : (
          <>
            <DrawerHeader title="Manage accounts" />
            {typedObjectEntries(MANAGE_ACCOUNTS_ACTIONS).map(
              ([actionKey, { icon: Icon, label }]) => (
                <Fragment key={actionKey}>
                  <button
                    type="button"
                    className="p-2 flex items-center text-button-sm gap-x-1.5"
                    onClick={() => {
                      setAction(actionKey);
                    }}
                  >
                    <Icon weight="fill" size={24} />
                    {label}
                  </button>
                  <div className="h-px bg-black-200 my-1 last:hidden" />
                </Fragment>
              ),
            )}
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
